/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * IN_PROGRESS until submitted or refused.
 * @export
 * @enum {string}
 */

export const SurveyResponseStatusDto = {
    InProgress: 'IN_PROGRESS',
    Submitted: 'SUBMITTED',
    Refused: 'REFUSED'
} as const;

export type SurveyResponseStatusDto = typeof SurveyResponseStatusDto[keyof typeof SurveyResponseStatusDto];



